var _path, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoodleGamepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31373D",
    d: "M2.13 14.856l-.004-.002S.075 27.271.075 29.061c0 1.824 1.343 3.302 3 3.302.68 0 1.3-.258 1.803-.678l10.166-8.938L2.13 14.856zm31.69 0l.004-.002s2.051 12.417 2.051 14.207c0 1.824-1.343 3.302-3 3.302-.68 0-1.3-.258-1.803-.678l-10.166-8.938 12.914-7.891z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#14171A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.975,
    cy: 15.551,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.975,
    cy: 15.551,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.975 7.051h16v16.87h-16z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 13.075,
    cy: 23.301,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#14171A",
    cx: 22.875,
    cy: 23.301,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#67757F",
    cx: 22.875,
    cy: 23.301,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#67757F",
    cx: 13.075,
    cy: 23.301,
    r: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 25.735,
    cy: 11.133,
    r: 1.603
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#77B255",
    cx: 25.735,
    cy: 17.607,
    r: 1.603
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#50A5E6",
    cx: 22.498,
    cy: 14.37,
    r: 1.603
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#DD2E44",
    cx: 28.972,
    cy: 14.37,
    r: 1.603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.148 12.514v-2.168c0-.279-.226-.505-.505-.505H9.085c-.279 0-.505.226-.505.505v2.168l1.284 1.285 1.284-1.285zm-2.569 3.63v2.168c0 .279.226.505.505.505h1.558c.279 0 .505-.226.505-.505v-2.168l-1.284-1.285-1.284 1.285zm5.269-3.1H11.68l-1.285 1.285 1.285 1.285h2.168c.279 0 .505-.227.505-.505V13.55c0-.279-.226-.506-.505-.506zm-5.799 0H5.88c-.279 0-.505.227-.505.505v1.558c0 .279.226.505.505.505h2.168l1.285-1.285-1.284-1.283z",
    fill: "#8899A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodleGamepad);
export default __webpack_public_path__ + "static/media/doodle-gamepad.1bffdf7cb80437e73ec2c914d3d7b7f3.svg";
export { ForwardRef as ReactComponent };